import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TableHeader as ShadcnTableHeader, TableHead, TableRow } from '@/components/ui/table';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { RateShopHeader, SortDirection } from '../shared/types/rate-shop-types';
import { truncateCompetitorName } from '../shared/utils/rate-formatters';

interface TableHeaderProps {
  headers: RateShopHeader[];
  onSort: (dataKey: string) => void;
  getSortIcon: (dataKey: string) => SortDirection;
}

export const TableHeader = ({ headers, onSort, getSortIcon }: TableHeaderProps) => {
  const renderSortIcon = (dataKey: string) => {
    const sortDirection = getSortIcon(dataKey);

    if (sortDirection === 'asc') {
      return <ArrowUp className='ml-2 h-4 w-4' />;
    }
    if (sortDirection === 'desc') {
      return <ArrowDown className='ml-2 h-4 w-4' />;
    }
    return <ArrowUpDown className='ml-2 h-4 w-4' />;
  };

  return (
    <ShadcnTableHeader>
      <TableRow>
        {headers.map((header) => {
          const displayName = truncateCompetitorName(header.title);

          return (
            <TableHead
              key={header.dataKey}
              className='px-3 py-1 text-center text-gray-500 text-xs uppercase font-medium tracking-wider bg-gray-50'
            >
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button
                      variant='ghost'
                      onClick={() => onSort(header.dataKey)}
                      className='h-auto p-0 text-xs font-medium text-gray-500 uppercase hover:text-gray-700 w-full flex items-center justify-center gap-1'
                    >
                      <span className='text-center'>{displayName}</span>
                      {renderSortIcon(header.dataKey)}
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{header.tooltip}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </TableHead>
          );
        })}
      </TableRow>
    </ShadcnTableHeader>
  );
};
